import { DateTime } from "luxon";

export const getTimezoneName = (zone: string) => {
  return zone.replace("/", " - ").replace("_", " ");
};

export const updateDateTimezone = (date: DateTime | null, zone: string) => {
  if (!date) return null;
  return date.setZone(zone);
};

export const updateDayTimezone = (date: DateTime | null, zone: string) => {
  if (!date) return null;

  const selectedDay = date.toFormat("MM-dd-yyyy");

  let updatedDay = updateDateTimezone(date, zone)!;
  const dayAfterTimezoneUpdate = updatedDay.toFormat("MM-dd-yyyy");

  if (dayAfterTimezoneUpdate !== selectedDay) {
    const shouldAddDay = updatedDay.offset < date.offset;
    updatedDay = shouldAddDay
      ? updatedDay.plus({ day: 1 })
      : updatedDay.minus({ day: 1 });
  }

  return updatedDay;
};

export const updateMonthTimezone = (date: DateTime, zone: string) => {
  const selectedMonth = date.month;

  let updatedMonth = updateDateTimezone(date, zone)!.startOf("month");
  const monthAfterTimezoneUpdate = updatedMonth.month;

  if (monthAfterTimezoneUpdate !== selectedMonth) {
    // if the user selected a timezone that resulted in a day change (e.g., NY -> LA means
    // it would go from, say, 1/1 @ 12:00AM to 12/31 @ 9:00PM), force the selected month to
    // be the same as the one that was previously selected
    const shouldAddMonth = updatedMonth.offset < date.offset;
    updatedMonth = shouldAddMonth
      ? updatedMonth.plus({ month: 1 })
      : updatedMonth.minus({ month: 1 });
  }

  return updatedMonth;
};
